import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ProjectCard from "../../components/ProjectCard/ProjectCard";

import { Fade } from "react-reveal";
import "./SanGabriel.css";
import { t } from "i18next";

function SanGabriel(props) {
  const theme = props.theme;
  const projects = {
    data: [
      {
        id: "0",
        name: t(
          "sections.home.competitive-advantage.advantages.titles.distribution"
        ),
        url: "#",
        description: t(
          "sections.home.competitive-advantage.advantages.contents.distribution"
        ),
        languages: [
          {
            name: t(
              "sections.home.competitive-advantage.advantages.titles.distribution"
            ),
            iconifyClass: "mdi-truck",
          },
        ],
      },
      {
        id: "1",
        name: t("sections.home.competitive-advantage.advantages.titles.haccp"),
        url: "https://github.com/Bauddhik-Geeks/Bauddhik-Geeks.github.io",
        description: t(
          "sections.home.competitive-advantage.advantages.contents.haccp"
        ),
        languages: [
          {
            name: t(
              "sections.home.competitive-advantage.advantages.titles.haccp"
            ),
            iconifyClass: "mdi-leaf",
          },
        ],
      },
      {
        id: "2",
        name: t(
          "sections.home.competitive-advantage.advantages.titles.facilities"
        ),
        url: "https://github.com/harikanani/e-commerce-frontend",
        description: t(
          "sections.home.competitive-advantage.advantages.contents.facilities"
        ),
        languages: [
          {
            name: t(
              "sections.home.competitive-advantage.advantages.titles.facilities"
            ),
            iconifyClass: "mdi-globe",
          },
        ],
      },
    ],
  };

  return (
    <div className="privacy-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="privacy-heading-div">
            <div className="privacy-heading-text-div">
              <h1
                className="privacy-heading-text"
                style={{ color: theme.text }}
              >
                SAN GABRIEL
              </h1>
            </div>
          </div>
        </Fade>

        {/*first*/}

        <div>
          <div className="skills-main-div">
            <Fade left duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/img_limones-arbol.jpg`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

            <div className="skills-text-div">
              <Fade right duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.content.0.1")}
                  </p>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.content.0.2")}
                  </p>
                </div>
              </Fade>
            </div>

          </div>
        </div>

        {/*second*/}

        <div>
          <div className="skills-main-div">

            <div className="skills-text-div-right">
              <Fade left duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.content.1.1")}
                  </p>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.content.1.2")}
                  </p>
                </div>
              </Fade>
            </div>

            <Fade right duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/img_flor-limon.jpg`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

          </div>
        </div>

        {/*third*/}

        <div>
          <div className="skills-main-div">
            <Fade left duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/empacadoras-1.jpg`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

            <div className="skills-text-div">
              <Fade right duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text bold"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.titles.3")}
                  </p>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    <ul>
                      <li>{t("sections.san-gabriel.content.3.1")}</li>
                      <li>{t("sections.san-gabriel.content.3.2")}</li>
                      <li>{t("sections.san-gabriel.content.3.3")}</li>
                      <li>{t("sections.san-gabriel.content.3.4")}</li>
                    </ul>
                  </p>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.content.3.5")}
                  </p>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    <b>{t("sections.san-gabriel.content.3.6")}</b>
                    <ul>
                      <li>{t("sections.san-gabriel.content.3.7")}</li>
                      <li>{t("sections.san-gabriel.content.3.8")}</li>
                      <li>{t("sections.san-gabriel.content.3.9")}</li>
                    </ul>
                  </p>
                </div>
              </Fade>
            </div>

          </div>
        </div>

        {/*forth*/}

        <div>
          <div className="skills-main-div">
            <Fade left duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/img-blog-3.jpg`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

            <div className="skills-text-div">
              <Fade right duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.persian-lime")}
                  </p>
                </div>
              </Fade>
            </div>

          </div>
        </div>

        {/*five*/}



      </div>
      <div className="projects-main">
        <div className="repo-cards-div-main">
          {projects.data.map((repo) => {
            return <ProjectCard repo={repo} theme={theme} />;
          })}
        </div>
      </div>
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="privacy-heading-div">
            <div className="privacy-heading-text-div">
              <h1
                className="privacy-heading-text"
                style={{ color: theme.text }}
              >
                {t('titles.COMMERCIALIZATION')}
              </h1>
            </div>
          </div>
        </Fade>
        <div>
          <div className="skills-main-div">

            <div className="skills-text-div-right">
              <Fade left duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.san-gabriel.content.4")}
                  </p>
                </div>
              </Fade>
            </div>

            <Fade right duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/logo-HACCP.png`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

          </div>
        </div>
      </div>

      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default SanGabriel;
